<template>
  <v-footer dark padless color="primary">
    <!-- <v-card flat tile class="white--text"> -->
    <v-container fluid>
      <v-row class="px-5">
        <!-- <v-col justify="center">
          <v-card-text class="white--text">
            <v-spacer></v-spacer>
            <h3>ติดต่อเรา</h3>
            <h4 class="py-3">
              15 ภาควิชาวิสัญญีวิทยา คณะแพทยศาสตร์ มหาวิทยาลัยสงขลานครินทร์
              ถ.กาญจนวนิช ต.คอหงส์ อ.หาดใหญ่ จ.สงขลา 90110
              <span
                class="mx-5"
              >
                <v-icon class="mx-3">mdi-phone-in-talk</v-icon>074-451651-2
              </span>
              <span class="mr-5">
                <v-icon class="mx-3">mdi-printer</v-icon>074-281656
              </span>
              <span>
                <v-icon class="mx-3">mdi-email-outline</v-icon>anespsuweb@gmail.com
              </span>
            </h4>
            <v-spacer></v-spacer>
          </v-card-text>
        </v-col>-->
        <v-col cols="7" justify="center">
          <v-card-text class="white--text">
            <v-spacer></v-spacer>
            <h3>ติดต่อเรา</h3>
            <h4 class="py-3">
              15 สาขาวิชาวิสัญญีวิทยา คณะแพทยศาสตร์ มหาวิทยาลัยสงขลานครินทร์
              ถ.กาญจนวนิช ต.คอหงส์ อ.หาดใหญ่ จ.สงขลา 90110
              <v-row class="py-1">
                <span class="mr-5">
                  <v-icon class="mx-3">mdi-phone-in-talk</v-icon>074-451651-2
                </span>
                <span class="mr-5">
                  <v-icon class="mx-3">mdi-printer</v-icon>074-281656
                </span>
                <span>
                  <v-icon class="mx-3">mdi-email-outline</v-icon>anespsuweb@gmail.com
                </span>
              </v-row>
            </h4>
            <v-spacer></v-spacer>
          </v-card-text>
        </v-col>
        <v-col cols="4" align="center" justify="center">
          <!-- <pre>{{dateCurrent(today)}}</pre> -->
          <div
            class="inset py-1"
            style="border-style: inset; border:3px inset gray; background-color:#007980;"
          >
            <!-- <v-card style="background-color:rgba(227, 236, 238, 0.9); color:black;"> -->
            <h4 class="py-1">จำนวนผู้เข้าชม</h4>
            <v-row class="py-0" justify="center">
              <v-col cols="7" class="py-0">
                <v-row>
                  <v-col cols="8" class="py-0 text-left">
                    <v-card-text class="py-0">
                      <v-icon small class="mr-1" style="margin-top:-6px">mdi-eye-outline</v-icon>ทั้งหมด
                    </v-card-text>
                    <v-card-text class="py-0">
                      <v-icon small class="mr-1" style="margin-top:-6px">mdi-human-male</v-icon>วันนี้
                    </v-card-text>
                    <v-card-text class="py-0">
                      <v-icon small class="mr-1" style="margin-top:-6px">mdi-account-multiple</v-icon>
                      เดือน{{" "+thaiFormatMonth(date_sync)}}
                    </v-card-text>
                    <v-card-text class="py-0">
                      <v-icon small class="mr-1" style="margin-top:-6px">mdi-human-male-female</v-icon>
                      ปี{{" "+(today.getFullYear()+543)+" "}}
                    </v-card-text>
                  </v-col>
                  <v-col cols="4" class="py-0 text-right">
                    <v-card-text class="py-0">{{all_viewer.total}}</v-card-text>
                    <v-card-text class="py-0">{{all_viewer.daily}}</v-card-text>
                    <v-card-text class="py-0">{{all_viewer.monthly}}</v-card-text>
                    <v-card-text class="py-0">{{all_viewer.yearly}}</v-card-text>
                  </v-col>
                </v-row>
              </v-col>

              <!-- </v-card> -->
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- </v-card> -->
  </v-footer>
</template>
<script>
export default {
  data() {
    return {
      all_viewer: {},
      date_sync: new Date().toISOString().substr(0, 10),
      today: new Date(),
    };
  },
  created() {
    this.getViewCount();
    var date = this.date_sync.split("-");
    var data = {
      month: date[1],
      year: date[0],
    };
  },

  methods: {
    setToday() {
      this.date_sync = this.today;
    },
    getViewCount() {
      let view_count = {};
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/viewstatistics")
        .then((response) => {
          // console.log(response.data);
          view_count = response.data;

          this.all_viewer = view_count;
        });
    },

    thaiFormatMonth(date) {
      var [year, month, day] = date.split("-");
      year = parseInt(year) + 543;
      switch (month) {
        case "01":
          month = "มกราคม";
          break;
        case "02":
          month = "กุมภาพันธ์";
          break;
        case "03":
          month = "มีนาคม";
          break;
        case "04":
          month = "เมษายน";
          break;
        case "05":
          month = "พฤษภาคม";
          break;
        case "06":
          month = "มิถุนายน";
          break;
        case "07":
          month = "กรกฎาคม";
          break;
        case "08":
          month = "สิงหาคม";
          break;
        case "09":
          month = "กันยายน";
          break;
        case "10":
          month = "ตุลาคม";
          break;
        case "11":
          month = "พฤศจิกายน";
          break;
        case "12":
          month = "ธันวาคม";
          break;

        default:
          break;
      }
      return month;
    },
  },
};
</script>
